import { Theme } from '@material-ui/core/styles';
import { TimelineConnectorClassKey } from '@material-ui/lab/TimelineConnector';

const MuiTimelineConnector = (theme: Theme): Partial<Record<TimelineConnectorClassKey, unknown>> => ({
    root: {
        backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600],
    },
});

export default MuiTimelineConnector;
